export default {
    linkList: {
        "companyLink": "Hakkımızda",
        "termsOfService": "Kullanım Şartları",
        "privacyPolicy": "Gizlilik İlkesi",
        "guaranteeOfRights": "Veri Sahiplerinin Hakkı",
        "customerSupport": "DESTEK",
        "cookiePolicy": "Çerez İlkesi",
        "declarationOfSafety": "Güvenlik・Emniyet Duyurusu",
        "youthProtectionPolicy": "Gençleri Koruma İlkesi",
        "communityPolicy": "Topluluk İlkesi",
        "operationPolicy": "İşleyiş İlkesi",
        "doNotSell": "Kişisel Bilgilerimi Satmayın",
        "gameGrade": "게임이용등급",
        "communityPolicyView": "커뮤니티정책",
        "servicePolicy": "서비스정책",
        "termsOfUse": "회원정책",
        "operationPolicyNCJ": "운영방침",
        "reportRightsInfringement": "권리침해신고",
    },
    footerWords: {
        "gameRelatedLaw": "Oyun Yasalarına Dair İlave Bilgi",
        "brandInformation": "Şirket Adı Bilgisi",
        "copyright": "Telif Hakkı",
        "channelingInfo": "NCSOFT, elektronik ticaret yoluyla Plaync üzerinden oyunları yönlendiren bir komisyoncudur ve bahsedilen oyunların bir satış ortağı değildir.<br>Sunulan oyunlarla ilgili tüm zorunluluklar ve sorumluluklar; şahsi e-ticaret ortağının yükümlülüğündedir. Onlarla ilişkili sorunlarda sorumlu taraf biz değiliz.",
    },
    infoCS: {
        "businessInformation": "İşletme Bilgilerini Görüntüle",
        "infoAddress": "Şirket Adı: NCSOFT Corporation, Şirket CEO'su: Kim Taek-Jin, İşletme Sicil Numarası: 144-85-04244, E-ticaret Sicili: 2013-Gyeonggi Seongnam-1268",
        "mobile": "Adres: 12, Daewangpangyo-ro 644beon-gil, Bundang-gu, Seongnam-si, Gyeonggi-do, Kore Cumhuriyeti. Müşteri DESTEK: +82 1566-7004. Fax: +82 02-2186-3499.",
        "pc": "주소 경기도 성남시 분당구 대왕판교로 644번길 12 고객상담 1600-0020 팩스 02-2186-3557",
        "other": "Adres: 12, Daewangpangyo-ro 644beon-gil, Bundang-gu, Seongnam-si, Gyeonggi-do, Kore Cumhuriyeti. Müşteri DESTEK: +82 1600-0020 (PC Oyunu), +82 1566-7004 (Mobil Oyun). Fax: +82 02-2186-3550 (PC Oyunu), +82 02-2186-3499 (Mobil Oyun).",
        "none": "",

        "infoEmail": "E-posta",
        "infoEmail-mobile": "MobileCS@ncsoft.com",
        "infoEmail-pc": "credit@ncsoft.com",
        "infoEmail-other": "credit@ncsoft.com/(PC Game)/MobileCS@ncsoft.com/(Mobile Game)",
        "infoEmail-none": "",
    },
    infoJP: {
        "jpTitle": "Başlık",
        "jpGenre": "Tür",
        "jpPrice": "Fiyat",
        "jpPriceValue": "Oynaması Ücretsiz (Uygulama içi satın alımlar sunar)",
        "jpOs": "Desteklenen İS",
        "jpDevelopedBy": "Geliştirici/Yayıncı",
        "jpReleaseDay": "Çıkış Tarihi",
        "jpReleaseDayValue_LW": "4 Kasım 2021",
    },
    country: {
        "KR": "Kore Cumhuriyeti",
        "TW": "Tayvan",
        "RU": "Rusya",
        "MY": "Malezya",
        "SA": "Suudi Arabistan",
        "SG": "Singapur",
        "AE": "Birleşik Arap Emirlikleri",
        "ID": "Endonezya",
        "JP": "Japonya",
        "QA": "Katar",
        "TH": "Tayland",
        "PH": "Filipinler",
        "HK": "Hong Kong",
        "UA": "Ukrayna",
        "BY": "Belarus",
        "LT": "Litvanya",
        "PL": "Polonya",
        "GR": "Yunanistan",
        "IL": "İsrail",
        "KW": "Kuveyt",
        "AT": "Avusturya",
        "US": "Amerika Birleşik Devletleri",
        "CA": "Kanada",
        "DE": "Almanya",
        "GB": "Birleşik Krallık",
        "FR": "Fransa",
        "BR": "Brezilya",
        "IT": "İtalya",
        "ES": "İspanya",
        "CL": "Şili",
        "NO": "Norveç",
        "SE": "İsveç",
        "IE": "İrlanda",
        "PT": "Portekiz",
        "FI": "Finlandiya",
        "DK": "Danimarka",
        "CH": "İsviçre",
        "AR": "Arjantin",
        "PE": "Peru",
        "MX": "Meksika",
        "KZ": "Kazakistan",
        "UZ": "Özbekistan",
        "AZ": "Azerbaycan",
        "GE": "Gürcistan",
        "MD": "Moldova",
        "AM": "Ermenistan",
        "MO": "Makao",
        "IN": "Hindistan",
        "PK": "Pakistan",
        "NL": "Hollanda",
        "RO": "Romanya",
        "AU": "Avustralya",
        "TR": "Türkiye",
        "EC": "Ekvador",
        "CO": "Kolombiya",
        "ZA": "Güney Afrika",
        "EG": "Mısır",
        "NC": "Küresel",
    },
}
